const FundTypeEnum = Object.freeze({
    EIS: 'EIS',
    SEIS: 'SEIS',
    SEISEIS: 'SEISEIS',
    IHT: 'IHT',
    PMI: 'PMI',
    OTHER: 'OTHER'
});

export default FundTypeEnum;
